<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Bar,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            default: null
        },
    },
    data: () => ({
        options: {
            responsive: true,
            curvature: 1,
            legend: {
                display: false
            },
            maintainAspectRatio: false,
            layout: {
                padding: {
                    left: 45,
                    right: 45,
                }
            },
            scales: {
                yAxes: [
                    {
                        stacked: true,
                        ticks: {
                            display: false,
                            beginAtZero: true,
                            suggestedMin: 0,
                            suggestedMax: 100,
                        },
                        gridLines: {
                            drawTicks: false,
                            drawBorder: false,
                            display: false,
                            color: '#fff'
                        }
                    }
                ],
                xAxes: [
                    {
                        stacked: true,
                        maxBarThickness: 24,
                        minBarLength: 0,
                        ticks: {
                            fontColor: '#fff',
                            fontFamily: 'Open Sans',
                            padding: 10,
                            autoSkipPadding: 0,
                            maxRotation: 0
                        },
                        gridLines: {
                            display: false,
                            color: 'transparent',
                        },
                    }
                ]
            }
        },
    }),
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>